var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8V32C0 36.4187 3.58133 40 8 40H32C36.4187 40 40 36.4187 40 32V8C40 3.58133 36.4187 0 32 0H8C3.58133 0 0 3.58133 0 8ZM32 37.3333H8C5.05467 37.3333 2.66667 34.9453 2.66667 32V8C2.66667 5.05467 5.05467 2.66667 8 2.66667H32C34.9453 2.66667 37.3333 5.05467 37.3333 8V32C37.3333 34.9453 34.9453 37.3333 32 37.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.424 34.6667V23.1974H27.064L27.9467 17.404H22.424V13.6814C22.424 13.0747 22.424 12.164 23.2973 11.4147C24.2453 10.6 25.1053 10.5867 26.572 10.5867H28.1747V5.67605C28.1747 5.67605 26.464 5.26538 23.464 5.26538C20.464 5.26538 16.22 6.63205 16.22 13.4987V17.404H11.1533V23.1987H16.1973V34.668H22.424V34.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.f69f8c36da9d98f08fbee19069e7c536.svg";
export { ForwardRef as ReactComponent };